import Base64 from '../../utils/base64';
import { handleResponse } from '../../utils/handle-response';
import * as apiHelper from '../../utils/apiHelper';

export function login(email, password) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            emailAddress: email,
            password: Base64.btoa(password)
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_LOGIN);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function infoByEmail(email) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            emailAddress: email,
        })
    };

    let url = apiHelper.ComposeUri(apiHelper.API_GET_INFO_BY_EMAIL);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}


export function loginNodeRED(user) {
    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            user: user,          
        })
    };

    let url = apiHelper.ComposeNodeRedUri(apiHelper.API_ACTION_LOGINNODERED);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function getSystemParameters() {

    const requestOptions = { method: 'GET' };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETSYSTEMPARAMETERS);

    return fetch(url, requestOptions).then(handleResponse);
}
